module.exports = __webpack_public_path__ + "img/pause.1bbbe9a5.svg";